import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import ListPageHeader from "../utilities/ListPageHeader";
import AgGridTable from "../utilities/AgGridTable";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { useMediaQuery, useTheme } from '@mui/material';
const Territories = () => {
      const theme = useTheme();
      const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [selectedRows, setSelectedRows] = useState([]);
    const [rowData, setRowData] = useState([]);
    const gridRef = useRef();
    const [error, setError] = useState();
    const [gridApi, setGridApi] = useState(null);
    const perPage = 10;
    const [snackState, setSnackState] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const [deleteDisable, setDeleteDisable] = useState(true);
    const navigate = useNavigate();
    const [columnDefs, setColumnDefs] = useState([
        { field: 'displayName', enableRowGroup: true, headerName: "Territory Name",minWidth:50 },
        { field: 'areaManager', enableRowGroup: true,minWidth:50 },
        { field: 'partners', enableRowGroup: true,minWidth:50 },
    ]);
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.territory}`;
    const companyURL=`${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.company}`;
     const baseUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;

    const handlePurge = () => {
        selectedRows.map(async (row) => {
            const id = row?._links?.self?.href.split('/').pop();
            try {
                await OAuthService.deleteData(url, id);
                setSuccessMsg("Data deleted Successfully")
                setSnackState(true);
                loadData();
            } catch (error) {
                setError(error.message);
            }
        })
    };

    const onBtExport = useCallback(() => {
        const params = {
            fileName: 'Territories.xlsx',
            sheetName: 'Territories'
        }
        gridRef.current.api.exportDataAsExcel(params);
    }, []);

    const onGridReady = useCallback((params) => {
        setGridApi(params.api);
    }, []);

    const loadData = async () => {
        gridApi?.showLoadingOverlay();
        try {
            const list = await OAuthService.getList(url + `?size=1000&sort=displayName,asc`);
            const userList  = await OAuthService.getList(`${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}` + `?size=1000&sort=firstName,asc`);
            let users;
            userList.data?._embedded?.users.map((data, key) => {
                const lastName = data?.lastName ? data.lastName : '';
                const middleName = data?.middleName ? data.middleName : '';
                const firstName = data?.firstName ? data.firstName : '';
                const name  = firstName + ' ' + middleName + ' ' + lastName;
                users = {...users, [data.email]: name }
            });
            let territories = list.data._embedded.territories;
            territories = await Promise.all(territories.map(async (territory) => {
                const partnerURL = `${companyURL}/companiesByTerritory/${territory.id}`;
                const partnerListResponse = await OAuthService.getList(partnerURL);
                let companyIds = partnerListResponse?.data;
                  const companyResponses = await Promise.all(
                    companyIds.map((id) =>
                      OAuthService.getList(`${baseUrl}/${id}`)
                    )
                  );
                
                  let partner = companyResponses.map((res) => {
                    const item = res?.data;
                    return {
                      id: item.id,
                      name: `${item.id} - ${item.name}`,
                    };
                  });
                const managers = territory?.areaManager?.map((data,index) => {
                    return data;
                })
                const partnerNames =partner.map((country) => (country.name));
                territory.partners = partnerNames.join(",");
                territory.areaManager = managers?.join(" , ")
                return territory;
            }));
            setRowData(territories);
        } catch (error) {
            setError(error.message);
        }finally {
    gridApi?.hideOverlay();
  }
    }

    useEffect(() => {
        if (gridApi) {
            loadData();
        }
    }, [gridApi]);


    const onSelectionChanged = (params) => {
        setSelectedRows(params.api.getSelectedRows());
    }
    
const goToRoleEdit = useCallback(
    (data) => {
      const id = data?._links?.self?.href.split('/').pop();
      if (id) {
        navigate('/editTerritory/' + id);
      }
    },
    [navigate],
  );

  const onRowDoubleClicked = (params) => {
    if (isMobile) return; // handled by onRowClicked instead
    goToRoleEdit(params?.data);
  };

  const onRowClicked = (params) => {
    if (!isMobile) return; // desktop keeps double-click only
    goToRoleEdit(params?.data);
  };
    useEffect(() => {
        if (selectedRows.length > 0) {
            setDeleteDisable(false)
        } else {
            setDeleteDisable(true)
        }
    }, [selectedRows])

    return (
        <>
            <ListPageHeader
                componentName="Territory"
                onBtExport={onBtExport}
                handlePurge={handlePurge}
                addPageLink="/addTerritory"
                pageName="Territory List"
                error={error}
                successMsg={successMsg}
                deleteDisable={deleteDisable}
                snackState={snackState}
                gridRef={gridRef}
            />
            <div className="h-full">
                <AgGridTable
                    rowData={rowData}
                    columnDefs={columnDefs}
                    onGridReady={onGridReady}
                    onSelectionChanged={onSelectionChanged}
                    onRowDoubleClicked={onRowDoubleClicked}
                    onRowClicked={onRowClicked}
                    gridRef={gridRef}
                    paginationPageSize={perPage}
                    cacheBlockSize={perPage}
                    saveGridStateName={'territoryList'}
                    rowHeight={28}
                />
            </div>
        </>
    );
}

export default Territories;
